import z from 'zod';
import { createListApiSchema } from '../General/schemas';

export const tagSchema = z
	.object({
		id: z.string(),
		name: z.string(),
		archived: z.boolean().optional(),
	})
	.describe('Tag');

export const tagsApiResponseSchema = createListApiSchema(tagSchema).describe('TagsApiResponse');
